import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield}}\n",{ moduleName: "client-portal/components/site/action-banner.hbs" })